export default "__VITE_ASSET__DFxj558t__"